import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-single-product" }
const _hoisted_2 = ["href"]



export default /*@__PURE__*/_defineComponent({
  __name: 'CustomLink',
  props: ['url', 'label'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: __props.url,
      class: "q-custom-link"
    }, _toDisplayString(__props.label), 9, _hoisted_2)
  ]))
}
}

})